/* eslint-disable sort-keys */
import { darken, lighten } from "polished"

export const colors = {
  black: "#1A1A1A",
  borderDark: "#70707040",
  danger: "#E74C3C",
  dangerDark: darken(0.1, "#E74C3C"),

  green: "#43a445",

  grey100: "#F6f6f6",
  grey200: "#ECF2F4",
  grey300: "#D0D0D0",
  grey400: "#575757",
  grey500: "#818181",
  grey700: "#959595",

  primary: "#ffffff",
  primaryDark: darken(0.1, "#6732ba"),
  primaryLight: lighten(0.25, "#6732ba"),
  primaryMedium: lighten(0.1, "#6732ba"),

  secondary: "#fff",

  success: "#25A52A",
  warning: "#FB8C00",

  white: "#fff",
}
